<template>
  <Vip-Good-list :good-list="bastList" :is-sort="false"></Vip-Good-list>
</template>

<script>
import VipGoodList from "@components/VipGoodList";
import {getVproduct} from "@/api/public";

export default {
  name: "VProduct",
  components: {
    VipGoodList
  },
  data: function () {
    return {
      bastList: []
    }
  },
  mounted: function () {
    getVproduct().then(res => {
      this.bastList = res.data
    })
  }
}
</script>

<style scoped>

</style>